import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios";
import { URLS } from "constants/api.constants";

export const feedbackGet = createAsyncThunk('feedback/feedbackget', async (params = {}, thunkAPI) => {
    try {
        const response = await axiosInstance.post(`${URLS.FEEDBACK.GET_FEEDBACK}?page=1`, params);
        
        if (response.data?.success) {
            return response.data;
        } else {
            return thunkAPI.rejectWithValue(response.data?.message || "Failed to fetch feedbacks");
        }
    } catch (error) {
        console.error("feedback API Error:", error);
        return thunkAPI.rejectWithValue(error?.message || "An error occurred while fetching feedbacks");
    }
});